export default __webpack_public_path__ + "static/media/mobiles.dcddf236.png";